import request from '@/utils/request'

export function loadData(){
    return request({
        url: '/platform/classification/getClassificationTree',
        method: 'get',
    })
}


// 新增
export function addType(data) {
    return request({
        url: '/platform/classification',
        method: 'post',
        data: data
    })
}

// 修改。
export function updateType(data) {
    return request({
        url: '/platform/classification',
        method: 'put',
        data: data
    })
}

// 删除
export function delType(id) {
    return request({
        url: '/platform/classification/' + id,
        method: 'delete'
    })
}

//适合MAP的树
export function loadDataMap(){
    return request({
        url: '/platform/classification/getClassificationTreeMap',
        method: 'get',
    })
}
//小秘平台树
export function getTree(){
    return request({
        url: '/platform/classification/getTree',
        method: 'get',
    })
}


